import React from "react";
import { Helmet } from 'react-helmet-async';
import '../../../assets/styles/Backend.css'
import backendHero from "../../../assets/images/backend.png";
import backendArch from "../../../assets/images/backend.png";

const BackendDevelopment = () => {
  return (
    <>
      <Helmet>
        {/* <!-- Primary Meta Tags for SEO --> */}
        <title> Backend Development – BuddyTech Solutions </title>
        <meta name="description" content="Robust backend architecture and APIs using Node.js, Express, Python, Django, or Java." />
        <meta name="keywords" content="backend development, API, Node.js, Django" />

        {/* <!-- Open Graph / Facebook Meta Tags --> */}
        <meta property="og:title" content="Backend Development – BuddyTech Solutions" />
        <meta property="og:description" content="Robust backend architecture and APIs using Node.js, Express, Python, Django, or Java." />
        <meta property="og:keywords" content="backend development, API, Node.js, Django" />
        <meta property="og:image" content="https://buddytechsolutions.in/assets/images/thumbnailimages.jpg" />
        <meta property="og:url" content="https://buddytechsolutions.in/services/development/backend" />
        <meta property="og:type" content="website" />

        {/* <!-- Optional: Facebook App ID --> */}
        {/* <!-- <meta property="fb:app_id" content="your_facebook_app_id" /> --> */}

        {/* <!-- Twitter Meta Tags --> */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Backend Development – BuddyTech Solutions" />
        <meta name="twitter:description" content="Robust backend architecture and APIs using Node.js, Express, Python, Django, or Java." />
        <meta name="twitter:keywords" content="backend development, API, Node.js, Django" />
        <meta name="twitter:image" content="https://buddytechsolutions.in/assets/images/thumbnailimages.jpg" />
      </Helmet>
      <div className="backend-container">
        <header className="backend-hero">
          <div className="backend-hero-content">
            <h1>Back-End Development</h1>
            <p>
              We build secure, scalable, and high-performance server-side applications that serve as the core of your digital product.
            </p>
          </div>
          <img src={backendHero} alt="Backend Development" className="backend-hero-img" />
        </header>

        <section className="backend-section">
          <div className="backend-text">
            <h2>What We Do</h2>
            <p>
              Our back-end developers are experts in creating and managing robust architectures, RESTful APIs, and real-time services using modern frameworks and best practices.
            </p>
            <ul>
              <li>Database Architecture & Management</li>
              <li>RESTful & GraphQL API Development</li>
              <li>Authentication & Authorization</li>
              <li>Server & Cloud Deployment</li>
              <li>Microservices & Scalability</li>
            </ul>
          </div>
          <img src={backendArch} alt="Backend Architecture" className="backend-img" />
        </section>

        <section className="backend-tools">
          <h2>Technologies We Use</h2>
          <div className="tools-grid">
            <span>Node.js</span>
            <span>Express.js</span>
            <span>NestJS</span>
            <span>MongoDB</span>
            <span>PostgreSQL</span>
            <span>MySQL</span>
            <span>Firebase</span>
            <span>Docker</span>
            <span>Redis</span>
            <span>AWS / GCP / Azure</span>
          </div>
        </section>

        <section className="contact-options">
          <div className="contact-card email">
            <h2>📧 Email</h2>
            <p>Send us an email for inquiries, support or collaboration opportunities.</p>
            <a href="mailto:developerjayaprakash91@gmail.com" target="_blank" rel="noopener noreferrer">
              Send Email
            </a>
          </div>

          <div className="contact-card whatsapp">
            <h2>💬 WhatsApp</h2>
            <p>Start a chat with us on WhatsApp for quick responses and updates.</p>
            <a href="https://wa.me/919842084312" target="_blank" rel="noopener noreferrer">
              Chat on WhatsApp
            </a>
          </div>

          <div className="contact-card phone">
            <h2>📞 Call Us</h2>
            <p>Prefer to talk directly? Give us a call anytime during business hours.</p>
            <a href="tel:+919842084312">Call Us</a>
          </div>
        </section>
      </div>
    </>
  );
};

export default BackendDevelopment;